/**************************************************
 * Nombre:       Tarjeta_Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Indicador = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontFamily: 'Raleway', fontSize: sCell ? 32 : 48, fontWeight: 800}}>{item.numero}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography
                    sx={{fontFamily: 'Raleway', fontSize: sCell ? 14 : 16, fontWeight: 300, color: '#7A7A7A'}}>
                    {item.nombre}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Indicador